export default __webpack_public_path__ + "static/media/powerpointIcon.4d969453.svg";